import React, { forwardRef } from 'react';
import './navbar.css';
import { Link } from 'react-router-dom';
import { Navbar as BootstrapNavBar } from 'react-bootstrap';
import EsquinaLogo from '../resources/images/resizedResto/logoRestoBlack.png';

const Navbar = forwardRef((_, ref) => {
  return (
    <BootstrapNavBar className="Nav-color" fixed="top" ref={ref}>
      <BootstrapNavBar.Brand>
        <Link to="/" className="img">
          <img
            src={EsquinaLogo}
            height={50}
            //height={50}
            style={{ padding: 10 }}
            alt="La Esquina"
          />
        </Link>
      </BootstrapNavBar.Brand>
    </BootstrapNavBar>
  );
});

Navbar.displayName = 'MainNavBar';

export default Navbar;
